import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Router } from "@angular/router";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import swal from "sweetalert2";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { EoiService } from "../../services/eoi/eoi.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { environment } from "../../../environments/environment";
import { PaginationComponent } from "../../layout/pagination/pagination.component";

@Component({
  selector: "app-eoi-table",
  templateUrl: "./eoi-table.component.html",
  styleUrls: ["./eoi-table.component.css"],
})
export class EoiTableComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  export_eoi: any;

  eois_raw_data: any;
  page: any = 0;
  base_url_for_pagination: any;
  last_page_url: any;

  uploadExcel: FormGroup;

  filterForm: FormGroup;

  projects: any;

  eoi_statuses: any;

  agents: any;

  filterActive: boolean = false;

  filterData: any = {};
  page_length: number = 15;

  constructor(
    public leadsService: LeadsService,
    public router: Router,
    private eoisService: EoiService,
    private slimLoadingBarService: SlimLoadingBarService,
    public fb: FormBuilder,
    public errorHandlerService: ErrorHandlerService,
    private reservationService: ReservationService
  ) {
    this.createEOIFilter();
    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  ngOnInit() {
    this.getEois();
    this.getProjects();
    this.getEoiStatuses();
    this.getAgents();
    this.export_eoi = `${
      environment.api_base_url
    }eois/export?token=${window.localStorage.getItem("token")}`;
  }

  getEoiStatuses() {
    this.eoisService.getEoiStatuses().subscribe((res: any) => {
      this.eoi_statuses = res;
    });
  }

  getAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (res: any) => {
        this.projects = res;
      },
      (err) => console.log(err)
    );
  }

  eoiModalActionOnOpen() {}

  eoiModalActionOnClose() {}

  getEois() {
    this.leadsService.getEois().subscribe(
      (data: any) => {
        this.eois_raw_data = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  createEOIFilter() {
    this.filterForm = this.fb.group({
      serial: [""],
      user_id: [undefined],
      status: [null],
      project_id: [null],
      lead_search: [""],
      eoi_number: [""],
    });
    if (this.userProfile.role != "Admin" && this.userProfile.role != "CFO") {
      this.filterForm.get("status").setValue("Available");
    }
  }

  exportTable() {
    let formModel = Object.assign({}, this.filterForm.value);
    if (!this.filterForm.value.user_id) formModel.user_id = "";
    formModel.is_export = 1;
    this.slimLoadingBarService.start();
    this.leadsService.exportTable(formModel).subscribe((res: any) => {
      window.open(res.url);
      this.slimLoadingBarService.complete();
    }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      };
  }

  getNewRecord(event) {
    this.eois_raw_data = event;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.createEOIFilter();
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }

  goToEdit(id) {
    console.log(id);
    this.router.navigate(["pages/eoi", id]);
  }

  goToEOIView(id) {
    this.router.navigate([`/pages/eoi-view/${id}`]);
  }

  handleUploadExcel(event) {
    console.log(event);
    console.log(event.target.files);
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.uploadExcel.get("file").setValue({
          filename: file.name,
          value: reader.result.toString().split(",")[1],
        });
      };
    }
  }

  uploadExcelMethod(modal) {
    const formModel = Object.assign({}, this.uploadExcel.value);
    console.log(formModel);
    if (!formModel.file) {
      swal("Oops...", "Files can not be empty!", "error");
    } else {
      let data = {
        file: formModel.file.value,
        file_name: formModel.file.filename,
      };
      this.slimLoadingBarService.start(() => {
        console.log("Loading complete");
      });
      console.log(data);
      this.eoisService.importEoi(data).subscribe(
        (data) => {
          console.log(data);
          modal.close();
          this.getEois();
          this.slimLoadingBarService.complete();
          swal("Woohoo!", "Files uploaded succesfully!", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
    }
  }

  exportEoi() {
    this.slimLoadingBarService.start();
    this.eoisService.exportEoi().subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  printReceipt(id) {
    this.slimLoadingBarService.start();
    this.eoisService.printReceipt(id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        window.open(res.url);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  redirectToLeadDetails(leadId) {
    if (!isNaN(leadId)) {
      this.router.navigate([`/pages/leads/${leadId}`]);
    }
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/eois/eoi-table/eoi-table.component.ts